import React from 'react';
import TablaRegistroContratista from './Tablas/TablaRegistroContratista';
import GraficoRegistroContratista from './Graficos/GraficoRegistroContratista';
import { VStack, Heading } from '@chakra-ui/react';
import ObrasRegistroContratistaDashboard from './Dashboard/ObrasRegistroContratistaDashboard';

const ObrasRegistroContratista: React.FC = () => {
  return (
    <VStack spacing={8} align="stretch">
      <Heading size="lg" textAlign="center" color="blue.700">
        Registro de Contratistas
      </Heading>
      <ObrasRegistroContratistaDashboard/>
      <TablaRegistroContratista />
      {/* <GraficoRegistroContratista /> */}
    </VStack>
  );
};

export default ObrasRegistroContratista;
